// extracted by mini-css-extract-plugin
export default {"wrapper":"RenderLoader_wrapper__-WvSS","header":"RenderLoader_header__H+Ejm","content":"RenderLoader_content__KpWDV","hintStop":"RenderLoader_hintStop__85XzB"};